// NPM Imports
import React, { useState } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Button } from "../../revvComponents";

// Internals Imports
import { GlobalUtils } from "../../utils";
import { IMAGE_URLS } from "../../constants";

// Destructure
const { readDataFromLocalStorage, writeDataToLocalStorage } = GlobalUtils;
const { SHIELD, awesomWebformLink: HEADER_IMG } = IMAGE_URLS;

const EsignDocInfoPopup = ({ sharingHash, user, doc_owner }) => {
  // Hooks for showing/hiding the shared doc info popup
  const [showSharedDocumentInfoPopup, updateInfoPopupFlag] = useState(true);

  const _handleClosePopup = () => {
    updateInfoPopupFlag(false);
    writeDataToLocalStorage("sharedDocInfoPopupkey", sharingHash);
  };

  const sharedDocInfoPopupStatus = readDataFromLocalStorage(
    "sharedDocInfoPopupkey",
  );
  return (
    <Modal
      open={
        showSharedDocumentInfoPopup && sharedDocInfoPopupStatus !== sharingHash
      }
      onClose={_handleClosePopup}
      closeOnOverlayClick={false}
      center
      classNames={{
        modal: "recipientdocinfopopup-modal",
        closeButton: "modal-close-btn-mobile-view",
      }}>
      <div className="recipientdocinfopopup-container">
        {/* ------ Recipient document info header(gif, recipient title and send info) section ------ */}
        <div className="recipientdocinfopopup-header">
          <div className="recipientdocinfopopup-img-wrapper">
            <img
              src={HEADER_IMG}
              alt="Revv"
              className="recipientdocinfopopup-img"
            />
          </div>
          <div className="recipientdocinfopopup-recipient-title">
            Hi {user.first_name}!
          </div>
          <div className="recipientdocinfopopup-sender-info">
            <b>{doc_owner.first_name} </b> has sent this document for you to{" "}
            <b>eSign</b>. Check out the menu at the top of the document to add{" "}
            <b>
              <i>Notes</i>
            </b>{" "}
            or upload files as{" "}
            <b>
              <i>Attachments.</i>
            </b>
          </div>
        </div>

        {/* ------ Recipient document info action button section------ */}
        <div className="recipientdocinfopopup-action-button-section">
          <Button
            type="four"
            className="recipientdocinfopopup-action-button"
            data-test="recipientdoc-info-popup-btn"
            onClick={_handleClosePopup}>
            View document
          </Button>
        </div>

        {/* ------ Recipient document footer info section  ------ */}
        <div className="recipientdocinfopopup-footer-info">
          <img
            src={SHIELD}
            data-test="recipientdocinfopopup-footer-info-img"
            className="recipientdocinfopopup-footer-infoimg"
            alt="Revv"
          />
          <span className="recipientdocinfopopup-footer-desc">
            This confidential document was sent to email ID{" "}
            <b>{user.user_email}</b>. If this is not you, please do not open the
            document and exit the browser.
          </span>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  const { user, doc_owner } = state.RevvSignStore;
  return {
    user,
    doc_owner,
  };
};

export default connect(mapStateToProps, null)(EsignDocInfoPopup);
